// ========== RYZO IMAGE SEARCH v3 ==========

(function () {
 
  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
 
  function getPageSize() {
  // мобилка оставляем как есть, десктоп делаем 15 (5 в ряд × 3 ряда)
  return isMobile() ? 12 : 15;
}


  // ---- I18N ----
  const I18N = {
    ru: {
      searchTitle: 'Поиск похожих товаров',
      loading: 'Ищем похожие товары…',
      noResults: 'Похожие товары не найдены',
      priceLabel: 'Цена',
      prev: 'Назад',
      next: 'Вперёд',
      page: 'Страница'
    },
    en: {
      searchTitle: 'Search similar products',
      loading: 'Searching for similar products…',
      noResults: 'No similar products found',
      priceLabel: 'Price',
      prev: 'Prev',
      next: 'Next',
      page: 'Page'
    },
    fr: {
      searchTitle: 'Recherche de produits similaires',
      loading: 'Recherche de produits similaires…',
      noResults: 'Aucun produit similaire trouvé',
      priceLabel: 'Prix',
      prev: 'Précédent',
      next: 'Suivant',
      page: 'Page'
    },
    nl: {
      searchTitle: 'Zoek vergelijkbare producten',
      loading: 'Vergelijkbare producten worden gezocht…',
      noResults: 'Geen vergelijkbare producten gevonden',
      priceLabel: 'Prijs',
      prev: 'Vorige',
      next: 'Volgende',
      page: 'Pagina'
    },
    de: {
      searchTitle: 'Ähnliche Produkte suchen',
      loading: 'Ähnliche Produkte werden gesucht…',
      noResults: 'Keine ähnlichen Produkte gefunden',
      priceLabel: 'Preis',
      prev: 'Zurück',
      next: 'Weiter',
      page: 'Seite'
    }
  };
const LOADING_MESSAGES = {
  ru: [
    'Ищем похожие штуки…',
    'Colibri шепчет нейросети…',
    'Подбираем что-то в ваш вайб…',
    'Секунду, сверяем стиль…'
  ],
  en: [
    'Looking for twins…',
    'Colibri whispers to the AI…',
    'Finding your vibe…',
    'Hold on, matching your style…'
  ],
  fr: [
    'On cherche les jumeaux…',
    'Colibri parle à l’IA…',
    'On trouve votre style…',
    'Un instant, on compare…'
  ],
  nl: [
    'Zoeken naar tweelingen…',
    'Colibri fluistert met de AI…',
    'We zoeken jouw vibe…',
    'Momentje, we vergelijken…'
  ],
  de: [
    'Wir suchen Zwillinge…',
    'Colibri flüstert mit der KI…',
    'Wir finden deinen Style…',
    'Kurz warten, wir vergleichen…'
  ]
};


  const LANG_RAW =
    (document.documentElement.getAttribute('lang') || 'ru-RU').toLowerCase();
  const LANG_SHORT = LANG_RAW.split('-')[0];
  const LANG = I18N[LANG_SHORT] ? LANG_SHORT : 'ru';
  const LOCALE = LANG_RAW || (LANG === 'ru' ? 'ru-RU' : 'en-US');

  function t(key) {
    return (I18N[LANG] && I18N[LANG][key]) || I18N.ru[key] || '';
  }

const ryzoState = {
  products: [],
  dom: null,
  renderedCount: 0,
  scrollAttached: false,
  progress: 0,
  progressTimer: null,
  loadingMsgTimer: null    // таймер для смены надписей
};



  // ---- Стили (один раз) ----
  (function injectRyzoStyles() {
    if (document.getElementById('clb-ryzo-styles-v3')) return;
    const style = document.createElement('style');
    style.id = 'clb-ryzo-styles-v3';
    style.textContent = `
    html.clb-ryzo-lock,
    body.clb-ryzo-lock {
      overflow: hidden !important;
      touch-action: none;
    }

.clb-ryzo-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;                  /* всегда flex */
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.55);

  opacity: 0;                     /* по умолчанию невидима */
  visibility: hidden;
  pointer-events: none;
    transition: opacity .38s ease;

}

.clb-ryzo-modal--visible {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}


 .clb-ryzo-modal-inner {
  width: 100%;
  max-width: 960px;
  max-height: 90vh;
  margin: 16px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 45px rgba(15,23,42,0.35);
  padding: 9px 11px 9px;
  position: relative;
  font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  display: flex;
  flex-direction: column;

  opacity: 0;
  transform: translateY(18px) scale(.94);
  transition:
    opacity .38s cubic-bezier(.22,.61,.36,1),
    transform .38s cubic-bezier(.22,.61,.36,1),
    box-shadow .38s ease;
}
.clb-ryzo-modal--visible .clb-ryzo-modal-inner {
  opacity: 1;
  transform: translateY(0) scale(1);
}


    .clb-ryzo-modal-close {
      border: none;
      background: transparent;
      font-size: 20px;
      cursor: pointer;
      line-height: 1;
      color: #4b5563;
      padding: 4px;
      margin-left: 8px;
    }

    .clb-ryzo-modal-title {
      margin: 0;
      font-size: 15px;
      font-weight: 700;
      color: #111827;
    }

    .clb-ryzo-header {
      padding-bottom: 0;
     
    }
.clb-ryzo-modal-inner {
  background-color: #f1f1f1; /* цвет рамки */
  
}

.clb-ryzo-modal-body {
  background-color: #ffffff; /* центр белый */
  border-radius: 16px;
}

    .clb-ryzo-header-top {
      display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
     margin-bottom: 4px; 
   
    }

       .clb-ryzo-product {
      display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 7px 4px;
    cursor: pointer;
    }


    .clb-ryzo-product-imgwrap {
      width: 60px;
      height: 60px;
      flex-shrink: 0;
      border-radius: 10px;
      overflow: hidden;
      background: #f3f4f6;
    }
    .clb-ryzo-product-imgwrap img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .clb-ryzo-product-text {
      min-width: 0;
    }
    .clb-ryzo-product-title {
      font-size: 13px;
      font-weight: 600;
      color: #111827;
      line-height: 1.35;
      max-height: 2.7em;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .clb-ryzo-product-price {
      margin-top: 3px;
      font-size: 13px;
      font-weight: 700;
      color: #16a34a;
    }

    .clb-ryzo-modal-body {
      margin-top: 6px;
      flex: 1 1 auto;
      overflow: auto;
    }

       .clb-ryzo-loading {
      padding: 32px 0;
      font-size: 13px;
      color: #4b5563;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      text-align: center;

      position: relative;   /* НОВОЕ: чтобы матрица была фоном */
      overflow: hidden;     /* НОВОЕ: обрежем края */
    }
    /* Матрица на заднем фоне */
    .clb-ryzo-matrix {
      position: absolute;
      inset: -40px; /* чуть шире, чем сам блок, чтобы не обрезалось */
      pointer-events: none;
      opacity: 0.20; /* полупрозрачная, чтобы не мешала */
      background-size: 140px 280px;
      background-image:
        linear-gradient(
          to bottom,
          rgba(34,197,94,0.0) 0%,
          rgba(34,197,94,0.35) 50%,
          rgba(34,197,94,0.0) 100%
        ),
        repeating-linear-gradient(
          to bottom,
          rgba(148,163,184,0.1) 0px,
          rgba(148,163,184,0.18) 1px,
          rgba(15,23,42,0.0) 20px
        );
      mix-blend-mode: screen;
      animation: clb-ryzo-matrix-scroll 9s linear infinite;
    }

    @keyframes clb-ryzo-matrix-scroll {
      0% {
        background-position: 0 0, 0 0;
      }
      100% {
        background-position: 0 280px, 0 280px;
      }
    }

    .clb-ryzo-scanner {
      width: 280px;       /* сканер чуть длиннее */
      height: 300px;
      border-radius: 18px;
      background: #020617; /* тёмный фон под картинкой */
      border: 1px solid rgba(148,163,184,0.75);
      position: relative;
      overflow: hidden;
      box-shadow: 0 20px 45px rgba(15,23,42,0.65);
    }

    /* Картинка, по которой ищем (внутри сканера) */
    .clb-ryzo-scan-img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scale(1.03); /* лёгкий зум, чтобы не было пустых краёв */
      filter: brightness(0.96) saturate(1.05);
      z-index: 0;
    }

    /* Цветной оверлей поверх картинки, но под линией */
    .clb-ryzo-scanner::before {
      content: '';
      position: absolute;
      inset: 0;
      background:
        radial-gradient(circle at 0 0, rgba(56,189,248,0.32), transparent 55%),
        radial-gradient(circle at 100% 100%, rgba(52,211,153,0.32), transparent 55%),
        linear-gradient(to bottom, rgba(15,23,42,0.3), rgba(15,23,42,0.9));
      mix-blend-mode: soft-light;
      pointer-events: none;
      z-index: 1;
    }


    /* бегущая полоса-сканер */
        .clb-ryzo-scan-line {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        to bottom,
        transparent 0%,
        rgba(96,165,250,0.0) 30%,
        rgba(96,165,250,0.55) 50%,
        rgba(96,165,250,0.0) 70%,
        transparent 100%
      );
      transform: translateY(-100%);
      animation: clb-ryzo-scan-line 1.4s linear infinite;
      mix-blend-mode: screen;
      z-index: 2; /* линия поверх картинки и оверлея */
    }

    @keyframes clb-ryzo-scan-line {
      0% {
        transform: translateY(-100%);
      }
      100% {
        transform: translateY(100%);
      }
    }

    /* точки снизу — «ищем» */
      .clb-ryzo-scan-dots {
      position: absolute;
      bottom: 8px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 5px;
      z-index: 3; /* точки выше всего */
    }


    .clb-ryzo-scan-dots span {
      width: 6px;
      height: 6px;
      border-radius: 999px;
      background: rgba(248,250,252,0.85);
      box-shadow: 0 0 8px rgba(248,250,252,0.8);
      animation: clb-ryzo-scan-dot 1.2s ease-in-out infinite;
      transform-origin: center;
    }

    .clb-ryzo-scan-dots span:nth-child(2) {
      animation-delay: 0.15s;
    }
    .clb-ryzo-scan-dots span:nth-child(3) {
      animation-delay: 0.3s;
    }

    @keyframes clb-ryzo-scan-dot {
      0%, 80%, 100% {
        transform: scale(0.6);
        opacity: 0.65;
      }
      40% {
        transform: scale(1);
        opacity: 1;
      }
    }

  .clb-ryzo-progress {
    margin-top: 14px;
    width: 100%;
    max-width: 360px;
    height: 20px;
    border-radius: 999px;
    background: rgba(15,23,42,0.12);
    border: 1px solid rgba(148,163,184,0.8);
    overflow: hidden;
  }

  .clb-ryzo-progress-bar-inner {
    height: 100%;
    width: 0%;
    border-radius: inherit;
    /* стартовый плавный градиент, потом его переписываем из JS */
    background: linear-gradient(90deg, #22c55e, #16a34a);
    transition: width .25s ease-out, background .35s ease-out;
  }


    @keyframes clb-ryzo-progress-gradient {
      0% {
        background-position: 0% 50%;
      }
      100% {
        background-position: 100% 50%;
      }
    }

    .clb-ryzo-progress-label {
      margin-top: 6px;
      font-size: 11px;
      color: #6b7280;
    }

    .clb-ryzo-loading-text {
  max-width: 260px;
  line-height: 1.5;
  font-size: 13px;
  font-weight: 600;     /* делаем текст более жирным */
  color: #111827;       /* более тёмный, читаемый */
}



  .clb-ryzo-grid {
  display: grid;
  /* карточка шире → помещается 5 штук вместо 6 */
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
  margin-top: 0px;
}

    .clb-ryzo-card {
      display: flex;
      flex-direction: column;
      text-decoration: none;
      background: #f9fafb;
      border-radius: 10px;
      padding: 8px;
      border: 1px solid #e5e7eb;
      transition: transform .16s ease, box-shadow .16s ease, border-color .16s ease;
      color: inherit;
    }
    .clb-ryzo-card-imgwrap {
      position: relative;
      padding-top: 100%;
      overflow: hidden;
      border-radius: 8px;
      background: #fff;
    }
    .clb-ryzo-card-imgwrap img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    } 
       .clb-ryzo-price-badge {
      position: absolute;
      right: 6px;
      bottom: 6px;
      padding: 3px 7px;
      border-radius: 999px;
      background: rgba(15, 23, 42, 0.88); /* тёмный полупрозрачный */
      color: #f9fafb;
      font-size: 11px;
      font-weight: 600;
      pointer-events: none;
      backdrop-filter: blur(2px);
      -webkit-backdrop-filter: blur(2px);
      white-space: nowrap;
    }

    .clb-ryzo-card-title {
      margin-top: 6px;
      font-size: 12px;
      color: #111827;
      line-height: 1.3;
      max-height: 3.1em;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .clb-ryzo-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 24px rgba(15,23,42,.16);
      border-color: #a855f7;
    }

    .clb-ryzo-empty {
      padding: 18px 0;
      text-align: center;
      font-size: 13px;
      color: #6b7280;
    }

   
.clb-ryzo-modal-body--center {
  display: flex;
  align-items: center;
  justify-content: center;
}

 
  
  
    /* Кнопка 🔍 на картинке */
    .media .clb-ryzo-search-btn {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 3;
      border: none;
      border-radius: 999px;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(15,23,42,0.75);
      color: #fff;
      cursor: pointer;
      padding: 0;
    }
    .media .clb-ryzo-search-btn:hover {
      background: rgba(37,99,235,0.9);
    }
    .clb-ryzo-search-btn .clb-ryzo-search-icon {
      width: 20px;
      height: 20px;
    }

    @media (max-width: 768px) {
  .clb-ryzo-modal {
    align-items: stretch;
    justify-content: stretch;
  }

  .clb-ryzo-modal-inner {
    margin: 0;
    width: 100%;
    max-width: 100%;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    display: flex;
    flex-direction: column;
  }

  .clb-ryzo-modal-body {
    margin-top: 6px;
    flex: 1 1 auto;
    overflow: auto;
    padding-bottom: 60px;
  }

  /* ВАЖНО: именно это делает 2 карточки в ряд */
  .clb-ryzo-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;          /* можно 8–12, подберёшь по вкусу */
  }

  /* Чуть уменьшить сами карточки, чтобы не были огромные */
  .clb-ryzo-card {
    padding: 6px;       /* было 8px — картинка станет чуть крупнее */
  }

  .clb-ryzo-card-title {
    font-size: 11px;
    -webkit-line-clamp: 2;
  }

 
  
}

    `;
    document.head.appendChild(style);
  })();

  // ---- Утилиты ----

  function clbEscapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

function lockScroll(lock) {
  // На десктопе НЕ трогаем скролл, чтобы не дёргать верстку
  if (!isMobile()) return;

  document.documentElement.classList.toggle('clb-ryzo-lock', lock);
  document.body.classList.toggle('clb-ryzo-lock', lock);
}
function updateLoadingProgressDom() {
  if (!ryzoState.dom || !ryzoState.dom.body) return;
  const body = ryzoState.dom.body;
  const barInner = body.querySelector('.clb-ryzo-progress-bar-inner');
  const label = body.querySelector('.clb-ryzo-progress-label');
  if (!barInner || !label) return;

  const value = Math.max(0, Math.min(100, Math.round(ryzoState.progress)));
  barInner.style.width = value + '%';
  label.textContent = value + '%';

  // плавный переход цвета: от зелёного к более «фиолетовому»
  const ratio = value / 100;                 // 0 → 1
  const baseHue = 140 + (220 - 140) * ratio; // 140° → 220° по HSL
  const c1 = `hsl(${baseHue}, 82%, 58%)`;
  const c2 = `hsl(${baseHue + 12}, 82%, 48%)`;
  barInner.style.background = `linear-gradient(90deg, ${c1}, ${c2})`;
}


function stopLoadingProgress() {
  if (ryzoState.progressTimer) {
    clearInterval(ryzoState.progressTimer);
    ryzoState.progressTimer = null;
  }
}

function startLoadingProgress() {
  stopLoadingProgress();
  ryzoState.progress = 0;
  updateLoadingProgressDom();

  ryzoState.progressTimer = window.setInterval(() => {
    // искусственно подползём максимум до 92%,
    // дальше ждём настоящий ответ от сервера
    if (ryzoState.progress >= 92) return;

    const delta = 1 + Math.random() * 3; // 1–4% за тик
    ryzoState.progress = Math.min(92, ryzoState.progress + delta);
    updateLoadingProgressDom();
  }, 140);
}

function completeLoadingProgress() {
  // когда реальные данные пришли — добиваем до 100%
  ryzoState.progress = 100;
  updateLoadingProgressDom();
  stopLoadingProgress();
}
function stopLoadingMessages() {
  if (ryzoState.loadingMsgTimer) {
    clearInterval(ryzoState.loadingMsgTimer);
    ryzoState.loadingMsgTimer = null;
  }
}

function startLoadingMessages() {
  stopLoadingMessages();
  if (!ryzoState.dom || !ryzoState.dom.body) return;

  const body = ryzoState.dom.body;
  const el = body.querySelector('.clb-ryzo-loading-text');
  if (!el) return;

  const list = LOADING_MESSAGES[LANG] || LOADING_MESSAGES.ru;
  if (!list || !list.length) return;

  let i = 0;
  el.textContent = list[0];

  ryzoState.loadingMsgTimer = window.setInterval(() => {
    i = (i + 1) % list.length;
    el.textContent = list[i];
  }, 2000); // каждые 2 секунды новая фраза
}


// Получаем название и цену: сначала из og:price, потом (если что) из видимой цены
function getProductMetaInfo() {
  let title = '';
  let priceText = '';

  // ---- 0. URL товара (для клика по шапке) ----
  const canonical = document.querySelector('link[rel="canonical"]');
  const url = canonical && canonical.href ? canonical.href : window.location.href;

  // ---- 1. Название из og:title ----
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle && ogTitle.content) {
    title = ogTitle.content.trim();
    const parts = title.split('–');
    if (parts.length > 1) {
      title = parts[0].trim();
    }
  }

  // ---- 2. Сначала пробуем og:price:amount (Shopify даёт её ровно) ----
  (function tryOgPrice() {
    const ogAmount = document.querySelector('meta[property="og:price:amount"]');
    const ogCurrency = document.querySelector('meta[property="og:price:currency"]');

    if (!ogAmount || !ogAmount.content) return;

    const raw = ogAmount.content.toString().trim();
    const normalized = raw.replace(/\s/g, '').replace(',', '.');
    const amount = Number(normalized);
    const currency = (ogCurrency && ogCurrency.content) || 'EUR';

    if (!isNaN(amount) && amount > 0) {
      try {
        priceText = new Intl.NumberFormat(LOCALE, {
          style: 'currency',
          currency
        }).format(amount);
      } catch (e) {
        priceText = amount + ' ' + currency;
      }
    }
  })();

  // ---- 3. Если по какой-то причине og:price не сработал — парсим видимую цену ----
  if (!priceText) {
    const priceSelectors = [
      '.price .price-item--regular',
      '.price .price-item--sale',
      '.product__info-container .price__regular .price-item',
      '.product__info-container .price__sale .price-item',
      '.product__info-container .price .price-item',
      '.product__info-container [data-price-type="final"]',
      '.product__info-container [itemprop="price"]',
      '[data-product-price]',
      '.product-price',
      '.product__price',
      '.price'
    ];

    for (const sel of priceSelectors) {
      const el = document.querySelector(sel);
      if (!el) continue;

      const fullText = (el.textContent || '').trim();
      if (!/[0-9]/.test(fullText)) continue;

      // Забираем только цифры — без пробелов, точек, запятых, валют
      const digits = fullText.replace(/[^\d]/g, '');
      if (!digits) continue;

      let amount;
      if (digits.length <= 2) {
        // 5 → 5 €, 12 → 12 €
        amount = Number(digits);
      } else {
        // 2246 → 22.46 €, 102246 → 1022.46 €
        amount = Number(digits) / 100;
      }
      if (isNaN(amount)) continue;

      // Простейшее определение валюты по символу
      let currency = 'EUR';
      if (/\$/.test(fullText)) currency = 'USD';
      else if (/£/.test(fullText)) currency = 'GBP';
      else if (/¥/.test(fullText)) currency = 'JPY';
      else if (/₽|руб/i.test(fullText)) currency = 'RUB';

      try {
        priceText = new Intl.NumberFormat(LOCALE, {
          style: 'currency',
          currency
        }).format(amount);
      } catch (e) {
        priceText = amount + ' ' + currency;
      }
      break;
    }
  }

  return { title, priceText, url };
}

  

// Пытаемся вытащить цену из ответа Ryzo и красиво отформатировать (по всем уровням объекта)
function formatRyzoPrice(item) {
  if (!item || typeof item !== 'object') return '';

  let raw = null;
  let currency = 'EUR';

  function scan(obj) {
    if (!obj || typeof obj !== 'object') return;
    for (const [key, val] of Object.entries(obj)) {
      if (raw === null && /price/i.test(key) && val !== null && val !== undefined && val !== '') {
        raw = val;
      }
      if (/(curr|currency)/i.test(key) && typeof val === 'string' && val.trim()) {
        currency = val.trim();
      }
      if (val && typeof val === 'object') {
        scan(val);
      }
      if (raw !== null) return;
    }
  }

  scan(item);

  if (raw === null || raw === undefined || raw === '') return '';

  let amount;

  if (typeof raw === 'number') {
    amount = raw; // считаем, что уже в нормальных единицах (евро/доллары)
  } else {
    const str = String(raw).trim();
    const digits = str.replace(/[^\d]/g, '');
    if (!digits) return str;

    if (digits.length <= 2) {
      amount = Number(digits);
    } else {
      amount = Number(digits) / 100; // 2246 → 22.46
    }
  }

  if (isNaN(amount)) return String(raw);

  try {
    return new Intl.NumberFormat(LOCALE, {
      style: 'currency',
      currency
    }).format(amount);
  } catch (e) {
    return amount + ' ' + currency;
  }
}


// даём второму файлу доступ к формату цены
window.formatRyzoPrice = formatRyzoPrice;



  // ---- Создание модалки ----
  function getRyzoDom() {
    let modal = document.querySelector('.clb-ryzo-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'clb-ryzo-modal';
      modal.innerHTML = `
  <div class="clb-ryzo-modal-inner">
    <div class="clb-ryzo-header">
      <div class="clb-ryzo-header-top">
        <h3 class="clb-ryzo-modal-title"></h3>
        <button class="clb-ryzo-modal-close" type="button">✕</button>
      </div>

      <div class="clb-ryzo-product">
        <div class="clb-ryzo-product-imgwrap">
          <img class="clb-ryzo-product-img" alt="">
        </div>
        <div class="clb-ryzo-product-text">
          <div class="clb-ryzo-product-title"></div>
          <div class="clb-ryzo-product-price"></div>
        </div>
      </div>
    </div>

    <div class="clb-ryzo-modal-body"></div>
  </div>
`;

      document.body.appendChild(modal);

       modal.querySelector('.clb-ryzo-modal-close').addEventListener('click', () => {
        modal.classList.remove('clb-ryzo-modal--visible');
        lockScroll(false);
        stopLoadingProgress();
        stopLoadingMessages();
      });

      // закрытие по клику вне окна
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.classList.remove('clb-ryzo-modal--visible');
          lockScroll(false);
          stopLoadingProgress();
          stopLoadingMessages();
        }
      });


    }

     const dom = {
      modal,
      title: modal.querySelector('.clb-ryzo-modal-title'),
      body: modal.querySelector('.clb-ryzo-modal-body'),
      productBlock: modal.querySelector('.clb-ryzo-product'),
      productImg: modal.querySelector('.clb-ryzo-product-img'),
      productTitle: modal.querySelector('.clb-ryzo-product-title'),
      productPrice: modal.querySelector('.clb-ryzo-product-price'),
      
    };


    return dom;
  }

// ---- Рендер карточек: бесконечный скролл вниз ----
function renderRyzoProducts(options) {
  const opts = options || {};
  const reset = !!opts.reset;
  const scrollToTop = !!opts.scrollToTop;

  if (!ryzoState.dom) return;
  const { body } = ryzoState.dom;
  const products = ryzoState.products || [];

  body.classList.remove('clb-ryzo-modal-body--center');



  if (!products.length) {
    body.innerHTML = `<div class="clb-ryzo-empty">${t('noResults')}</div>`;
    return;
  }

  const pageSize = getPageSize(); // размер "порции" для догрузки

  // при первом рендере или при новом поиске — очищаем и создаём сетку
  if (reset || !body.querySelector('.clb-ryzo-grid')) {
    body.innerHTML = `<div class="clb-ryzo-grid"></div>`;
    ryzoState.renderedCount = 0;
  }

  const grid = body.querySelector('.clb-ryzo-grid');
  if (!grid) return;

  const start = ryzoState.renderedCount;
  const end = Math.min(start + pageSize, products.length);

  // всё уже отрисовано
  if (start >= end) return;

  const slice = products.slice(start, end);

  const fragmentHtml = slice.map((item) => {
    const title = item.title || '';
    const image = item.imageurl || '';
    const url = item.url || '#';

    const price = formatRyzoPrice(item);
    const priceHtml = price
      ? `<span class="clb-ryzo-price-badge">${clbEscapeHtml(price)}</span>`
      : '';

    return `
      <a class="clb-ryzo-card" href="${url}" target="_blank" rel="noopener">
        <div class="clb-ryzo-card-imgwrap">
          <img src="${image}" alt="${clbEscapeHtml(title)}">
          ${priceHtml}
        </div>
        <div class="clb-ryzo-card-title">
          ${clbEscapeHtml(title)}
        </div>
      </a>
    `;
  }).join('');

  grid.insertAdjacentHTML('beforeend', fragmentHtml);

  ryzoState.renderedCount = end;

  if (scrollToTop) {
    try {
      body.scrollTo({ top: 0, behavior: 'instant' });
    } catch (e) {
      body.scrollTop = 0;
    }
  }
}
// ---- Подключаем бесконечный скролл ----
function setupInfiniteScroll() {
  if (!ryzoState.dom || ryzoState.scrollAttached) return;

  const body = ryzoState.dom.body;
  if (!body) return;

  ryzoState.scrollAttached = true;

  body.addEventListener('scroll', () => {
    // если всё уже подгрузили — выходим
    if (!ryzoState.products || ryzoState.renderedCount >= ryzoState.products.length) return;

    const threshold = 120; // запас до низа, когда начинаем догружать
    if (body.scrollTop + body.clientHeight >= body.scrollHeight - threshold) {
      renderRyzoProducts(); // догружаем следующую порцию
    }
  });
}

async function runRyzoSearch({ imageUrl, mode = 'full', source = null } = {}) {
  if (!imageUrl) return;

  const dom = getRyzoDom();
  ryzoState.dom = dom;
  ryzoState.products = [];
  ryzoState.renderedCount = 0;
  ryzoState.scrollAttached = false;
  stopLoadingProgress();
  ryzoState.progress = 0;


  // Заголовок и инфо по текущему товару
  dom.title.textContent = t('searchTitle');

  const metaInfo = getProductMetaInfo();
  dom.productImg.src = imageUrl;
  dom.productTitle.textContent = metaInfo.title || '';
  dom.productPrice.textContent = metaInfo.priceText
    ? `${t('priceLabel')}: ${metaInfo.priceText}`
    : '';

  // клик по шапке → открыть текущий товар в новой вкладке
  if (dom.productBlock && metaInfo.url) {
    dom.productBlock.onclick = () => {
      window.open(metaInfo.url, '_blank');
    };
  }

    if (mode === 'full') {
    // Показываем модалку с «сканером», прогресс-баром и фоном-матрицей
    dom.body.innerHTML = `
      <div class="clb-ryzo-loading">
        <div class="clb-ryzo-matrix"></div>

                <div class="clb-ryzo-scanner">
          <img class="clb-ryzo-scan-img" src="${imageUrl}" alt="">
          <div class="clb-ryzo-scan-line"></div>
          <div class="clb-ryzo-scan-dots">
            <span></span><span></span><span></span>
          </div>
        </div>


        <div class="clb-ryzo-progress">
          <div class="clb-ryzo-progress-bar-inner"></div>
        </div>
        <div class="clb-ryzo-progress-label">0%</div>

        <div class="clb-ryzo-loading-text">${t('loading')}</div>
      </div>
    `;

    dom.body.classList.add('clb-ryzo-modal-body--center');

    dom.modal.classList.add('clb-ryzo-modal--visible');
    lockScroll(true);

        // стартуем анимацию процентов + смену фраз
    startLoadingProgress();
    startLoadingMessages();
  }

 else {
    // PREVIEW: модалку не показываем, просто готовим данные
    dom.body.innerHTML = '';
    dom.body.classList.remove('clb-ryzo-modal-body--center');
    
  }

  try {
    // 1) качаем картинку с CDN
    const imgResp = await fetch(imageUrl);
    if (!imgResp.ok) throw new Error('Image download failed: ' + imgResp.status);
    const imgBlob = await imgResp.blob();

    // 2) FormData для Ryzo
    const formData = new FormData();
    formData.append('search_type', 'image');
    formData.append('image', imgBlob, 'search-image.jpg');
    formData.append('shop_id', 'undefined');
    formData.append('filters', '{}');
    formData.append('limit', '100'); // можно до 100
    formData.append('offset', '0');
    formData.append('sort_by', 'Country');
    formData.append('Country', 'BE');
    formData.append('language', LANG);

    // 3) запрос к приложению Ryzo
    const response = await fetch('/apps/ryzo/api/v1/search/query/?shop=undefined', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error('Ryzo status ' + response.status);
    }

     const data = await response.json();
    const products = Array.isArray(data.similar_images) ? data.similar_images : [];
    ryzoState.products = products;
    ryzoState.renderedCount = 0;

        if (mode === 'full') {
      completeLoadingProgress();

      setTimeout(() => {
        stopLoadingMessages();
        renderRyzoProducts({ reset: true, scrollToTop: true });
        setupInfiniteScroll();
      }, 160);
    }


    // Сигнал наружу (для второго файла)
    window.dispatchEvent(
      new CustomEvent('clb:ryzo:results', {
        detail: {
          mode,
          products,
          source,
          imageUrl
        }
      })
    );
   } catch (err) {
    console.error(err);

      if (mode === 'full') {
      stopLoadingProgress();
      stopLoadingMessages();
      dom.body.classList.remove('clb-ryzo-modal-body--center');
      dom.body.innerHTML = `<div class="clb-ryzo-empty">Ошибка: ${clbEscapeHtml(err.message)}</div>`;
    } else {

      window.dispatchEvent(
        new CustomEvent('clb:ryzo:results', {
          detail: {
            mode,
            products: [],
            error: err.message,
            source,
            imageUrl
          }
        })
      );
    }
  }

}


  // ---- Глобальный запуск из других скриптов (второй файл) ----
  window.addEventListener('clb:ryzo:search', (e) => {
    if (!e || !e.detail) return;
    const { imageUrl, mode, source } = e.detail;
    if (!imageUrl) return;

    const safeMode = mode === 'preview' ? 'preview' : 'full';
    runRyzoSearch({
      imageUrl,
      mode: safeMode,
      source: source || null
    });
  });

window.addEventListener('clb:ryzo:openModal', () => {
  const dom = ryzoState.dom || getRyzoDom();
  ryzoState.dom = dom;
  if (!dom) return;

  if (ryzoState.products && ryzoState.products.length) {
    renderRyzoProducts({ reset: true, scrollToTop: true });
    setupInfiniteScroll();
  }

  dom.modal.classList.add('clb-ryzo-modal--visible');
  lockScroll(true);
});



  // ---- Главный обработчик клика по 🔍 (режим full, старое поведение) ----
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.clb-ryzo-search-btn');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const imageUrl = btn.dataset.ryzoImageUrl;
    if (!imageUrl) return;

    // вызываем универсальный движок в режиме "как раньше"
    runRyzoSearch({
      imageUrl,
      mode: 'full',
      source: btn
    });
  }, true);
})();

